export default "__VITE_ASSET__DY40d1nt__"